module.exports = __webpack_public_path__ + "static/21-03-02_11-26-11_4127-d595ce264aa6a4a4cfa3b182a9a9ddc0.png";